var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardHeaderConnectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.3485V18.9433C1 9.04597 9.02866 1 18.9433 1H21.3485C31.2459 1 39.2919 9.02867 39.2919 18.9433V38.5305C39.2919 38.9458 38.9458 39.2919 38.5305 39.2919H18.9433C9.04596 39.2919 1 31.2632 1 21.3485Z",
    stroke: "#FF6B35",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1875 32.8594C26.5387 32.8594 31.6875 27.4867 31.6875 20.8594C31.6875 14.232 26.5387 8.85938 20.1875 8.85938C13.8362 8.85938 8.6875 14.232 8.6875 20.8594C8.6875 22.779 9.11946 24.5933 9.88748 26.2024C10.0916 26.6299 10.1595 27.1187 10.0412 27.5801L9.35624 30.2514C9.05889 31.411 10.0756 32.4718 11.1869 32.1616L13.7468 31.4469C14.189 31.3234 14.6574 31.3943 15.0672 31.6072C16.6091 32.4087 18.3478 32.8594 20.1875 32.8594ZM15.5875 22.3594C15.1112 22.3594 14.725 22.7623 14.725 23.2594C14.725 23.7564 15.1112 24.1594 15.5875 24.1594H21.9125C22.3888 24.1594 22.775 23.7564 22.775 23.2594C22.775 22.7623 22.3888 22.3594 21.9125 22.3594H15.5875ZM14.725 19.0594C14.725 18.5623 15.1112 18.1594 15.5875 18.1594H24.7875C25.2638 18.1594 25.65 18.5623 25.65 19.0594C25.65 19.5564 25.2638 19.9594 24.7875 19.9594H15.5875C15.1112 19.9594 14.725 19.5564 14.725 19.0594Z",
    fill: "#FF6B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHeaderConnectIcon);
export default __webpack_public_path__ + "static/media/dashboard-header-connect-icon.e66aa51503b00c527d1b12b4cc84569e.svg";
export { ForwardRef as ReactComponent };